import styles from './CompareHeading.module.scss';

export interface CompareHeadingLines {
  line1?: string;
  line2?: string;
}

const getLines = (heading?: CompareHeadingLines): string[] =>
  [heading?.line1, heading?.line2]
    .map((line) => line?.trim() ?? '')
    .filter(Boolean);

export const hasHeading = (heading?: CompareHeadingLines): boolean =>
  getLines(heading).length > 0;

interface CompareHeadingProps {
  heading?: CompareHeadingLines;
  className?: string;
}

/** The compare table's section title: one `<h2>`, each authored line on its own row. */
const CompareHeading = ({ heading, className }: CompareHeadingProps) => (
  <h2 className={className}>
    {getLines(heading).map((line, i) => (
      // eslint-disable-next-line react/no-array-index-key -- two fixed slots; the lines may repeat
      <span key={i} className={styles.line}>
        {line}
      </span>
    ))}
  </h2>
);

export default CompareHeading;
